import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Header() {

    const [collapsed, setCollapsed] = useState(true);
    const toggleNavbar = () => setCollapsed(!collapsed);

    return (<React.Fragment>
        <Navbar dark expand="md">
            <div className="container">
                <NavbarToggler onClick={toggleNavbar} />
                <NavbarBrand style={{
                    color: '#FFFFFF'
                }} href="/">
                    <img src='assets/images/logo.png' alt='' />
                    <b style={{
                        fontSize: 25,
                        marginLeft : 10
                    }}>
                        Venus Stats
                    </b>
                </NavbarBrand>
                <Collapse isOpen={!collapsed} navbar>
                    <Nav navbar>
                        <NavItem>
                            <NavLink to='/' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-house" /></span><b>Home&nbsp;&nbsp;</b>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to='/whales' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-sack-dollar" /></span><b>Whales&nbsp;&nbsp;</b>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to='/liquidations' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-scale-unbalanced-flip" /></span><b>Liquidations&nbsp;&nbsp;</b>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to='/prime' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-medal" /></span><b>Prime&nbsp;&nbsp;</b>
                            </NavLink>
                        </NavItem>
                        {/*
                        <NavItem>
                            <NavLink to='/isolatedLending' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-people-group" /></span><b>IsolatedLending&nbsp;&nbsp;</b>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to='/stables' className="nav-link">
                                <span><FontAwesomeIcon icon="fa-solid fa-file-invoice-dollar" /></span><b>StableRates&nbsp;&nbsp;</b>
                            </NavLink>                            
                        </NavItem>
                */}
                    </Nav>
                </Collapse>
            </div>
        </Navbar>
        <div className="jumbotron">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-12">
                        <h2><FontAwesomeIcon icon="fa-solid fa-chart-simple" size="2x" />&nbsp;&nbsp;Stats for №1 Lending platform on BSC</h2>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment >);
}

export default Header;